import { Injectable } from '@angular/core';
import { EntityType, pluralToSingular } from '../enums/entity-type.enum';

@Injectable({
    providedIn: 'root'
})
export class EntityTypeService {

  private map: { [key: string]: string } = {
    basket: "סלים (DANA)",
    expedition: "משלחות  חפירה",
    hachraza: "אתרי עתיקות מוכרזים",
    license: "רישיונות חפירה",
    locus: "לוקוסים (DANA)",
    objects: "פריטים באוצרות המדינה",
    publication: "פרסומי רשות העתיקות",
    fragment:"קטעים ממגילות מדבר יהודה",
    dana_pdfs:"תיקי חפירה דיגיטליים"
  };

  private reverseMap: { [key: string]: string };

  constructor() {
    this.reverseMap = Object.keys(this.map).reduce((acc: { [key: string]: string }, key) => {
      acc[this.map[key]] = key;
      return acc;
    }, {});
  }

  translate(key: string): string {
    return this.map[key] || key;
  }

  reverseTranslate(key: string): string {
    return this.reverseMap[key] || key;
  }
  public getSingleEntityType(entityType: string): EntityType {
    return pluralToSingular[entityType as keyof typeof pluralToSingular] || entityType;
  }
}
